import React from 'react';
import bellSvg from '../../assets/icons/notifications-outline.svg?raw';
import { svgInner } from './svgInner';

const BELL = svgInner(bellSvg);

/**
 * Ionicons notifications-outline — Alerts sidebar icon.
 *
 * Drawn from the icon file rather than a copy of its path data; the file's own
 * stroke width and caps come with it.
 */
export const NavBell = ({ size = 20, className = '', ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 512 512"
    fill="none"
    className={className}
    aria-hidden="true"
    dangerouslySetInnerHTML={{ __html: BELL }}
    {...props}
  />
);
